<div class="card">
	<div class="card-body">
		<h5 class="card-title">Edit application</h5>
		<div class="card-text" *ngIf="application$ | async as application">
			<div class="form-group" [formGroup]="formGroup">
				<label class="form-label">Display name</label>
				<dx-text-box [formControlName]="'displayName'" [as-validator]="customErrors">
				</dx-text-box>
			</div>
			<div class=form-group>
				<label class="form-label">Image</label>
				<dx-file-uploader class="moveField" selectButtonText="Select image" labelText="or Drop image here" accept="image/*"
					uploadMode="useForm" (onValueChanged)="valueChanged($event)">
				</dx-file-uploader>
				<button class="btn btn-clear btn-primary" (click)="clearImage()">Clear image</button>
				<div class="row">
					<div class="col-sm-2">
						<span>Selected image</span><br>
						<img #preview [hidden]="!image" class="images" [src]="getPreviewImage()">
					</div>
					<div class="col-sm-2">
						<span>Current image</span><br>
						<img class="images" [src]="getUrl('/application-logos/'+ application.imageRef)">
					</div>
				</div>
				<div class="btn-row row">
					<button type="button" class="btn btn-success" (click)="save(application)">
						Save
					</button>
					<button type="button" class="btn btn-primary" (click)="cancel()">
						Cancel
					</button>
				</div>
			</div>
		</div>
	</div>
</div>
